import { fetchInfrastructurePage } from "../services/contentApi";
import { ServicePageProvider, useServicePage, useServiceSection } from "./ServicePageContext";

export function InfrastructurePageProvider({ children }) {
  return (
    <ServicePageProvider fetchPage={fetchInfrastructurePage}>
      {children}
    </ServicePageProvider>
  );
}

export const useInfrastructurePage = useServicePage;
export const useInfrastructureSection = useServiceSection;
